// services/contact/queries.ts

import { useMutation } from '@tanstack/react-query'
import { apiCreateContact } from './api'
import { CreateContactPayload, CreateContactResponse } from './type'

export const useCreateContactMutation = () => {
    return useMutation<CreateContactResponse, Error, CreateContactPayload>({
        mutationFn: (payload) => apiCreateContact(payload),
    })
}